<template>
  <div class="row dashboard-info-widgets">
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="info-widget">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="ion ion-md-cloud-outline text-primary stats-icon"></i>
              {{totalVms}}
            </div>
            <div class="stats-title">{{'dashboard.totalVms' | translate}}</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="info-widget">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="ion ion-md-arrow-up text-primary stats-icon"></i>
              {{runningVms}}
            </div>
            <div class="stats-title">{{'dashboard.running' | translate}}</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="info-widget brand-danger">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="ion ion-md-arrow-down text-white stats-icon"></i>
              {{stoppedVms}}
            </div>
            <div class="stats-title">{{'dashboard.stopped' | translate}}</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
    <div class="col-md-6 col-xl-3">
      <vuestic-widget class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="ion ion-md-cash stats-icon icon-wide"></i>
              {{unpaidInvoices}}
            </div>
            <div class="stats-title">{{'dashboard.unpaidInvoices' | translate}}</div>
          </div>
        </div>
      </vuestic-widget>
    </div>
  </div>
</template>

<script>


  export default {
    name: 'dashboard-info-widgets',

    data () {
      return {
        totalVms: 0,
        runningVms: 0,
        stoppedVms: 0,
        unpaidInvoices: 0,
      }
    },
    methods: {
      setData (data) {
        this.totalVms = data.vms.length
        for (var i in data.vms) {
          if (data.vms[i].status && data.vms[i].status === 'running') {
            this.runningVms++
          } else {
            this.stoppedVms++
          }
        }
        this.unpaidInvoices = data.unpaid_invoices.length
      },
    },
    created () {
    },

    mounted () {
      // this.$refs.circleProgress.$data.value = 70
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../sass/_variables.scss";

  .stats-number, .stats-title {
    line-height: 1;
  }

  .info-widget-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    &.has-chart {
      justify-content: space-between;
    }

    .stats {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }

  .stats-number {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 2.625rem;
    margin-bottom: 0.5rem;

    .stats-icon {
      font-size: 1.5625rem;
      position: absolute;
      top: 0.625rem;
      left: -1.25rem;

      &.icon-wide {
        left: -1.875rem;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardInfoWidgets.vue